<template>
  <CSDialog v-model="showDialog" position="top">
    <CSCard style="width: 700px; max-width: 80vw">
      <CSCardSection class="text-white bg-negative">
        <div class="text-h6 text-center">User Inactive</div>
      </CSCardSection>
      <q-separator />

      <CSCardSection>
        <div class="text-center">
          User Inactive. You will be logged out in {{ displayTime }} mins
        </div>
      </CSCardSection>

      <CSCardActions align="right">
        <CSAsyncButton
          class="primary"
          label="Stay Logged In"
          @click="onStayLogged"
        />
      </CSCardActions>
    </CSCard>
  </CSDialog>
</template>

<script setup lang="ts">
import CSDialog from "@/components/CharitySystem/CSDialog.vue";
import CSCard from "@/components/CharitySystem/CSCard.vue";
import CSCardSection from "@/components/CharitySystem/CSCardSection.vue";
import CSCardActions from "@/components/CharitySystem/CSCardActions.vue";
import CSAsyncButton from "@/components/CharitySystem/CSAsyncButton.vue";
import { computed } from "vue";
import { useStore } from "@/store";
import SecurityUseCase from "@/usecases/SecurityUseCase";
import { processResponse } from "@/shared/helperFunctions";

const store = useStore();

const timer = computed(() => store.state.logoutTimeInSeconds || 0);

const showDialog = computed(() => store.state.showLogoutDialog);

const displayTime = computed(() =>
  timer.value > 0
    ? `0${Math.floor(timer.value / 60)} : ${((timer.value % 60) + "").padStart(
        2,
        "0"
      )}`
    : "00 : 00"
);

async function onStayLogged() {
  const securityUseCase = new SecurityUseCase();
  const result = await securityUseCase.updateToken();
  processResponse(result, (content) => {
    if (content?.user != null)
      store.commit("mutStoreCurrentUser", content.user);
    store.dispatch("actionToggleShowLogoutDialog", false);
  });
}
</script>
